import { render, staticRenderFns } from "./czy-warto-miec-konto-u-wiecej-niz-jednego-brokera.md?vue&type=template&id=4909321e&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports